var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mainContentDiv',{staticClass:"h-100 left-container"},[(_vm.tableOptions)?_c('sideTable',{ref:"sideTable",attrs:{"initOptions":_vm.tableOptions}}):_vm._e(),_c('centerDialog',{ref:"schoolListDialog"},[_c('div',{staticClass:"w-50"},[_c('inputCenter',{attrs:{"initOptions":_vm.initOptions_school}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }